import { render, staticRenderFns } from "./SupergroupBreadcrumb.vue?vue&type=template&id=4e215143"
import script from "./SupergroupBreadcrumb.vue?vue&type=script&lang=js"
export * from "./SupergroupBreadcrumb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports